import PageModule from "@insite/client-framework/Types/PageModule";
import { ConnectedFooter } from "@sonic-equipment/ui";
import * as React from "react";

function reloadPage() {
    let href = window.location.href;
    const switchingLanguageParameter = "SwitchingLanguage=true";
    if (!href.includes(switchingLanguageParameter)) {
        if (window.location.href.indexOf("?") === -1) {
            href += "?";
        } else {
            href += "&";
        }
        href += switchingLanguageParameter;
    }
    window.location.href = href;
}

const Footer: React.FunctionComponent = () => {
    return <ConnectedFooter source="shop" onCountryLanguageChange={() => reloadPage()} />;
};

const pageModule: PageModule = {
    component: Footer,
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "Footer" instead of this constant.
 */
export const FooterContext = "Footer";
